import React from "react";
import { motion } from "framer-motion";
import key_1 from "../assets/key-benifits/operator.png";
import key_2 from "../assets/key-benifits/for-players.png";

const benefits = [
  {
    title: "For Operators",
    image: key_1,
    alt:"Casino Slots Machine Operator's Dashboard",
    title2: "Casino Slots Machine Operator's Dashboard",
    points: [
      "Customizability: Manage every aspect: game features, terminal settings, hardware, and jackpots.",
      "Efficiency: Simplified customer and terminal management tools.",
      "Real-Time Analytics: Detailed reports on player behavior, game success, and finances.",
      "Flexible Jackpots: Choose between per machine or linked jackpots."
    ]
  },
  {
    title: "For Players",
    image: key_2,
    alt:"Slot Zone for Players",
    title2: "Slot Zone for Players",
    points: [
      "Enhanced Experience: Over 50 slot game features and high-quality hardware.",
      "Bigger Wins with Linked Jackpots: Larger prize pools across multiple machines.",
      "Convenient Kiosk System: Easy cashouts and voucher printing."
    ]
  }
];

const KeyBenefits = () => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8, ease: "easeOut" }}
      className="container mx-auto px-4 py-6 max-w-[80rem]"
    >
      <motion.h2
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8, ease: "easeOut", delay: 0.2 }}
        className="text-3xl md:text-5xl font-bold text-black text-center md:mb-8"
      >
        Key Benefits
      </motion.h2>

      <div className="grid grid-cols-1 md:grid-cols-2  gap-12">
        {benefits.map((benefit, index) => (
          <motion.div
            key={index}
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, ease: "easeOut", delay: index * 0.3 }}
            whileHover={{ scale: 1.05, boxShadow: "0px 10px 20px rgba(0, 0, 0, 0.15)" }}
            className="bg-white shadow-lg rounded-lg p-6"
          >
            <motion.img
              src={benefit.image}
              alt={benefit.alt}
              title={benefit.title2}
              className="w-full h-100 object-cover rounded-md mb-4"
              initial={{ opacity: 0, scale: 0.8 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.5, ease: "easeOut", delay: index * 0.2 }}
            />

            <h3 className="md:text-2xl text-xl font-extrabold mb-2 text-black text-start poppins-font">
              {benefit.title}
            </h3>
            <hr className="w-16 border-t-2 border-red-500 mb-3" />

            <ul className="list-disc pl-5 md:text-[18px] text-[14px] lg:text-base text-gray-600 text-justify poppins-font2 leading-relaxed">
              {benefit.points.map((point, i) => (
                <motion.li
                  className="md:py-2 py-1 text-start lg:text-base text-[14px] md:text-[18px] poppins-font2 "
                  key={i}
                  initial={{ opacity: 0, x: -10 }}
                  animate={{ opacity: 1, x: 0 }}
                  transition={{ delay: i * 0.2, duration: 0.3 }}
                >
                  {point}
                </motion.li>
              ))}
            </ul>
          </motion.div>
        ))}
      </div>
    </motion.div>
  );
};

export default KeyBenefits;
